<template>
  <div>
    <!--    MODALS -->
    <confirmation-box id="confirmSending"
                      :main-msg="['Tu vas envoyer le devoir au prof.',
               'Après tu ne pourras plus le modifier.',
               'Veux-tu vraiment l\'envoyer ?']"
                      ok-msg="Oui, je l'envoie"
                      cancel-msg="Non, je le garde"
                      @ok="submit"
    />
    <b-modal
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        hide-header
        id="sendingLoadingScreen"
        centered
        title="Envoi du Texte">
      <mutable-icon
          :icons="[
                        {status:0,module:'spinner',variant:'primary', text:'Envoie en Cours...'},
                        {status:1,icon:'check-circle', scale:'3', variant:'success', text:'Envoie terminé avec succès'},
                        {status:2,icon:'exclamation-circle', scale:'3', variant:'danger', text:'Échec de l\'envoie'},
                        ]"
          :current="sendingStatus"
      />
    </b-modal>
    <correction-modal
        :error="correction.error"
        v-model="correction.error"
        :replace="replace"
        :texte_original="item.texte_original"/>

    <!--    //Exercise-->
    <exercice-display v-if="item.exercice && !isTeacher()" :exercice="item.exercice"/>

    <h5 v-if="!canSubmit()"
        class="text-primary">
      Ton texte: {{ item.title }}
    </h5>
    <text-display
        class="ql-container ql-snow ql-editor ql-blank"
        v-if="canShowOriginal()"
        id="original-text"
        :html="item.texte_original">
    </text-display>
    <text-display
        label="Document"
        class="instructions"
        v-if="item.document"
        id="instructions"
        :html="item.document">
    </text-display>
    <exercice-display v-if="item.exercice && isTeacher()" :exercice="item.exercice"/>
    <h5
        class="text-primary"
        v-if="item.corrige">
      La correction
    </h5>
    <vue-editor
        v-if="canEdit() || item.corrige"
        id="editor"
        v-model="content"
        :editorOptions="editorSettings"
        :editorToolbar="customToolbar"
        :disabled="!canEdit()"
        ref="editor"
    />
    <b-button-toolbar class="ml-1 mt-1">
      <b-btn variant="outline-primary" @click="retour" class="mr-1">RETOUR</b-btn>
      <b-btn variant="primary" @click="confirmSubmit" class="mr-1" v-if="canSubmit()">{{ TEXT_SUBMIT(item) }}</b-btn>
      <b-btn variant="primary" @click="save" class="mr-1" v-if="canEdit()" :disabled="!canSave()">SAUVER</b-btn>
      <!--      <b-btn variant="primary" class="mr-1" @click="$bvModal.show('exercice')" v-if="showExercice">VOIR SUJET</b-btn>-->
    </b-button-toolbar>
  </div>
</template>

<script>
import {VueEditor} from "vue2-editor";
import {GetToolBar} from "@/js/toolbar"
import {addCorrection, getTrimSelection, htmlToLines, replaceElem} from "@/js/utils";
import {Auth, Exercice, LocalID, Textes} from "@/js/caller";
import MutableIcon from "@/components/mutableIcon";
import TextDisplay from "@/components/textDisplay";
import CorrectionModal from "../correctionModal";
import ConfirmationBox from "../confirmationBox";
import ExerciceDisplay from "@/components/ExercicesComponents/exerciceDisplay";

const textMethods = {
  TEXT_SUBMIT(item) {
    return "ENVOYER " + (!item.fini ? "AU PROF" : "A L'ELEVE")
  },
  htmlToLines
}

export default {
  name: "textEditor",
  props: {
    item: Object,
  },
  data: function () {
    return {
      // item          : {},
      exercice: null,
      content: "",
      customToolbar: GetToolBar(),
      editorSettings: {scrollingContainer: "html"},
      modal: {range: {index: 0, length: 0},},
      correction: {error: ""},
      //Sending Text
      showSendLoading: false,
      sending: false,
      sendingStatus: 0,

    }
  },
  components: {
    ExerciceDisplay,
    // ExerciceView,
    ConfirmationBox,
    CorrectionModal,
    TextDisplay,
    MutableIcon,
    //ConfirmationBox,
    VueEditor,
  },
  methods: {
    // Modal
    show() {
      this.correction.error = this.getFocus();
      if (this.correction.error === "") return;
      this.$bvModal.show('correction');
    },
    replace(text, correction, comment) {
      const quill = this.getEditor().quill;
      const {index, length} = this.modal.range;
      replaceElem(quill, index, length, correction);
      addCorrection(quill, text, correction, comment);
      this.$bvModal.hide("correction");
    },
    //Exercice
    showExercice() {
      return this.item?.exercice && Auth.IsTeacher();
    },
    //Editor
    getEditor() {
      return this.$refs.editor
    },
    getFocus() {
      const quill = this.getEditor().quill;
      const selection = quill.selection;
      console.log(selection.getRange())
      console.log(selection.getNativeRange())
      const {index, length} = selection && selection.savedRange;
      const {text, range} = getTrimSelection(quill.root, index, length)
      this.modal.range = range
      return text
    },

    retour() {
      this.$router.back()
    },

    isTeacher() {
      return Auth.IsTeacher();
    },
    canEdit() {
      return Auth.IsTeacher() || this.canSubmit();
    },
    canSave() {
      const comparator =
          (LocalID.isLocalID(this.item.id) || !this.item.fini) ?
              this.item.texte_original : this.item.texte_corrige;
      return this.content !== comparator
    },
    canSubmit() {
      const {item} = this
      return LocalID.isLocalID(item.id) || !item.fini || (Auth.IsTeacher() && !item.corrige);
    },

    confirmSubmit() {
      this.$bvModal.show("confirmSending")
    },
    save() {
      if (!this.canSave()) return;
      if (LocalID.isLocalID(this.item.id) || !this.item.fini) { // SAVE LOCAL
        this.item.texte_original = this.content;
        Textes.SaveLocal(this.item);
      } else { // SAVE ONLINE
        this.item.texte_corrige = this.content;
        Textes.Correct(this.item).then(() => this.$forceUpdate());
      }
    },
    submit() {
      const self = this
      self.sending = true;
      const finish = (status) => {
        self.sendingStatus = status
        setTimeout(() => {
          this.$bvModal.hide("sendingLoadingScreen");
        }, 2000)
        setTimeout(() => {
          self.reset();
        }, 4000)
      }
      self.$bvModal.show("sendingLoadingScreen")
      if (Auth.IsTeacher() && this.item.fini) {
        this.item.texte_corrige = this.content;
        this.item.corrige = 1;
        Textes.Correct(this.item).then(
            () => finish(1),
            () => finish(2),
        )
      } else {
        const {item} = this;

        const {id, ...data} = item;
        if (!LocalID.isLocalID(id)) data.id = item.id;
        data.texte_original = this.content;
        Textes.Submit(data).then((res) => {
          Textes.discardLocal(item.id)
          item.id = res.id;
          item.texte_original = this.content;
          item.fini = 1
          finish(1)
        }, () => {
          finish(2)
        },);
      }
    },
    reset() {
      this.sending = false;
      this.sendingStatus = 0;
    },

    updateEditors() {
      const els = document.querySelectorAll('.quillWrapper')

      els.forEach(e => {
        const id = e.children[1].id
        if (id === "original-text") {
          e.className += " mb-4" // add margin
          e.children[0].className += " d-none" // remove toolbar
        }
        if (id === "editor") {
          if (this.canEdit()) {
            e.children[0].className = e.children[0].className.replace(" d-none", "")
          } else {
            e.children[0].className += " d-none" // remove toolbar
          }
        }
      })
    },
    canShowOriginal() {
      const {item} = this
      return !LocalID.isLocalID(item.id) && item.fini
    },
    ...textMethods,
  },
  created() {
    const {item} = this
    if (Auth.IsTeacher()) {
      this.content = (item.texte_corrige && item.texte_corrige !== "") ? item.texte_corrige : item.texte_original
    } else {
      this.content = item.corrige ? item.texte_corrige : item.texte_original;
    }
    this.updateEditors();
    console.log(item);
  },
  mounted() {
    this.updateEditors();
    //Update toolbar functions
    const correctButton = document.querySelectorAll('.ql-correct');
    const saveButton = document.querySelectorAll('.ql-save');
    if (correctButton.length) correctButton.forEach(e => e.onclick = this.show.bind(this));
    if (saveButton.length) saveButton.forEach(e => {
      e.onclick = this.save.bind(this);
      e.setAttribute("disabled", "disabled");
      e.className += " disabled";
    });

  },
  beforeUpdate() {
    this.updateEditors();
    const saveButton = document.querySelector('.ql-save');
    if (!saveButton) return
    if (this.canSave()) {
      saveButton.disabled = false;
      saveButton.className = saveButton.className.replace(" disabled", "");
    } else {
      saveButton.setAttribute("disabled", "disabled");
      saveButton.className += " disabled";
    }
  },
}
</script>

<style scoped>
.instructions {
  border: 1px solid #ccc;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  min-height: 0;
  background-color: #eee;
  padding: 12px 15px;
}

.ql-toolbar.ql-snow.d-none + .ql-container.ql-snow {
  border-top: 1px solid #ccc;
}

.ql-save, .ql-correct {
  color: rgb(67, 67, 67)
}

.ql-save.disabled:hover {
  color: rgb(67, 67, 67) !important;
}

.ql-save.disabled {
  opacity: 0.65;
}

#contenu .ql-toolbar {
  top: 71px;
}

.ql-toolbar {
  position: sticky;
  position: -webkit-sticky;
  z-index: 10;
  top: 0;
  background-color: var(--light);
}

span.vs__selected {
  position: absolute;
  height: 28px;
}

.card {
  margin: 0 0 1rem 0 !important;
}

.exercice-toggle.collapsed::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.exercice-toggle.not-collapsed::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
</style>